import React, { useEffect, useState, useRef } from 'react';
import ReactGA from "react-ga4";
import { Link, useHistory } from "react-router-dom";
import SimplifiedHeader from '../components/SimplifiedHeader'
import NotificationBar from '../components/NotificationBar'
import Cta from '../components/Cta'
import SignInForm from './SignInForm'
import AuthService from '../services/AuthService'
import { useNotification } from '../providers/NotificationProvider';
import { useTheme } from '../providers/ThemeProvider'
import {
  useLocation
} from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import LoadingBar from 'react-top-loading-bar';

import useTitle from '../hooks/useTitle'

const queryString = require('query-string');

const LoginApp = () => {
  const AUTH_URL = AuthService.AUTH_URL;
  const REDIRECT_URL = AuthService.REDIRECT_URL;
  const COGNITO_CLIENT_ID = AuthService.COGNITO_CLIENT_ID;
  const COGNITO_RESET_PASSWORD_URL = AuthService.COGNITO_RESET_PASSWORD_URL;

  const history = useHistory();

  const [ notification, notificationDispatch ] = useNotification();
  const [ theme, themeDispatch ] = useTheme();

  useTitle("Welcome Back | The Convoy | Save on everyday business expenses.");

  const loadingBarRef = useRef(null);

  let query = useLocation().search;
  let preferences = {}

  useEffect(() => {
    if (query) {
      let params = queryString.parse(query);

      if (params.code) {
        notificationDispatch({ type: 'notification/message', payload: { message: "Logging in." } });
  
        AuthService.getTokenViaCode(params.code).then((response) => {
          let login = response.data.data.login;
  
          if (login.success === true) {
            localStorage.setItem('AUTH_TOKEN', login.token)
            //localStorage.setItem('preferences', preferences)

            notificationDispatch({ type: 'notification/message', payload: { message: login.message } });
            //themeDispatch({ type: 'theme/set', payload: preferences });
            history.go('/');
          } else if (login.code == 404) {
            notificationDispatch({
              type: "notification/message",
              payload: {message: "New User Detected"}
            });
    
            ReactGA.gtag("event", "login");
  
            history.push('/register?_ref=' + login.token);
          
          } else {
            notificationDispatch({ type: 'notification/error', payload: { message: login.message } });
            window.scrollTo(0, 0)
          }
        }).catch((e) => {
          notificationDispatch({
            type: 'notification/error',
            payload: {
              message: "Error Logging in."
            }
          });
          window.scrollTo(0, 0)
        });
      } 
    }
  }, []);

  return (
    <div>
      <SimplifiedHeader showRegister="true" />
      <NotificationBar />
      <LoadingBar color='#0173FF' ref={loadingBarRef} />

      <div className="container mx-auto bg-white">
    
        <div className="bg-white">
          <div className="md:max-w-login-container mx-auto text-center py-12">
            <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile 2xl:text-login-hero block">Welcome back!</span>
                </h2>
            </div>
  
            <div className="mt-5 px-0 md:max-w-login-field font-subtitle flex-none mx-auto">
              <span className="text-grey-dark text-login-subtitle-mobile 2xl:text-login-subtitle">Login to get access to savings exclusive to Members of The Convoy.</span>
            </div>
  
            <div className="mt-5">
              <small className="font-subtitle text-grey-light text-xs 2xl:text-sm">By logging in, I agree to the <a className="border-b-2" href="/terms-of-service">Terms of Use</a> and <a href="/privacy-policy" className="border-b-2">Privacy Policy.</a></small>
            </div>

            <div className="mt-5 flex justify-center">
              <a 
                className="inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-sm 2xl:text-lg rounded-full text-black bg-white hover:text-white hover:bg-blue-700"
                href={`${AUTH_URL}/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URL}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=aws.cognito.signin.user.admin+email+openid+profile`}
              ><FontAwesomeIcon icon={['fab', 'google']} /><span className="ml-4">Continue with Google</span></a>
            </div>
  
            <div className="mt-5 md:mt-10 md:w-120 font-content relative mx-auto">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-grey-light text-terms-subtitle-mobile md:text-terms-subtitle">Or sign in with email</span>
              </div>
            </div>
  
            <SignInForm loadingBarRef={loadingBarRef} />
  
            <div className="mt-7 font-content text-subtitle-mobile md:text-subtitle text-black ">
              <Link to="/register">
                <div>Don’t have an account?</div> 
                <div className="text-blue-600">Register to get access to exclusive deals</div>
              </Link>
              <div className="mt-8 relative mx-auto">
                <a 
                  href="/forgot"
                  className="text-black border-b-2 border-transparent hover:border-blue-500">
                    Having trouble logging in?
                </a>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginApp;
